import { connect } from 'react-redux';
import DaftarSiswaPPDBGeneral from '../../../views/Student/DataSiswa/DaftarSiswaPPDBGeneral.student.view';
import { getStudent } from '../../../states/thunks/student.thunk';
import {
  getClasses, getParamOptions, getStudentExitOptions, getParamOptionsAcademics, getPeriodsOptions, getClassesOptions, getPrmLevels, getSchoolUnitsOptions,
} from '../../../states/thunks/options.thunk';
import { listStudentPPDB, listStudentPPDBGeneral, listStudentPPDBUPPRicci } from '../../../states/thunks/academics.thunk';


function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    user: state.user,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
    handleGetStudent: () => dispatch(getStudent()),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleListStudentPPDB: (payload, goback) => dispatch(listStudentPPDB(payload, goback)),
    // getStudentOptions: (payload) => dispatch(getStudentOptions(payload)),
    getStudentExitOptions: payload => dispatch(getStudentExitOptions(payload)),
    getParamOptions: (payload, type) => dispatch(getParamOptions(payload, type)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    getClassesOptions: payload => dispatch(getClassesOptions(payload)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    handleListStudentPPDBGeneral: (payload, goback) => dispatch(listStudentPPDBGeneral(payload, goback)),
    handleListStudentsPPDBUppRicci: (payload, goback) => dispatch(listStudentPPDBUPPRicci(payload, goback)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DaftarSiswaPPDBGeneral);
